import React from 'react'
import PropTypes from 'prop-types'
import { Container, Textfield, Checkbox } from '@scentregroup/ui'
import { withRouter } from 'react-router-dom'
import analyticsUtils from '../../../helpers/analytics-utils'
import style from './index.module.scss'

const MAX_PRICE = 100000

function renderPrice(value) {
  const dollars = Math.floor(value / 100)
  return `$${dollars > MAX_PRICE / 100 ? '1000+' : dollars}`
}

function roundPriceValues({ minPrice, maxPrice }) {
  return {
    minPrice: Math.floor(minPrice / 100) * 100,
    maxPrice: Math.ceil(maxPrice / 100) * 100,
  }
}

class PriceFilter extends React.Component {
  static propTypes = {
    buildUrl: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    onSale: PropTypes.bool,
    showSale: PropTypes.bool,
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const updatedProps = Object.assign(
      {},
      nextProps,
      roundPriceValues(nextProps)
    )

    if (
      Object.keys(prevState).find(key => prevState[key] !== updatedProps[key])
    ) {
      return {
        minPrice: updatedProps.minPrice,
        maxPrice: updatedProps.maxPrice,
        onSale: nextProps.onSale || false,
      }
    }

    return null
  }

  constructor(props) {
    super(props)
    this.state = {
      ...roundPriceValues(props),
      onSale: props.onSale || false,
    }
  }

  onBlur = () => {
    const { minPrice, maxPrice } = roundPriceValues(this.props)
    if (this.state.minPrice !== minPrice || this.state.maxPrice !== maxPrice) {
      analyticsUtils.gaTagTracking({
        event: analyticsUtils.events.FILTER_PRICE,
        eventCategory: analyticsUtils.categories.PRODUCT_FILTER,
        eventAction: analyticsUtils.actions.FILTER_PRICE,
        eventLabel: 'Change',
        minPrice: this.state.minPrice,
        maxPrice: this.state.maxPrice,
        onSale: this.state.onSale,
      })

      this.updateFilter({
        maxPrice: this.state.maxPrice,
        minPrice: this.state.minPrice,
      })
    }
  }

  updateFilter = update => {
    const url = this.props.buildUrl(update)
    this.props.history.push(url)
  }

  updatePrice = type => event => {
    // Parse out any values that are not numbers
    const numberString = event.target.value.replace(/\D/g, '')
    const parsedValue = parseInt(numberString || 0)
    // Need to have the values in cents to match the filter expectations
    const cents = parsedValue * 100
    this.setState(prevState => Object.assign({}, prevState, { [type]: cents }))
  }

  submitHandler = type => event => {
    event.preventDefault()
    this.onBlur(type)
  }

  toggleOnSale = () => {
    const update = { onSale: !this.state.onSale }
    this.setState(update)
    this.updateFilter(update)
  }

  render() {
    const textFieldClassNames = {
      label: style.label,
      field: style.field,
      wrapper: style.textfieldWrapper,
    }

    return (
      <Container className={style.priceFilterWrapper} type="full">
        <Checkbox
          checked={this.state.onSale}
          label="Sale items only"
          classNames={{
            label: style.label,
            wrapper: style.checkbox,
            field: style.field,
          }}
          disabled={!this.props.showSale}
          onChange={this.toggleOnSale}
        />
        <Container className={style.priceFilter} type="full">
          <div className={style.priceField}>
            <form onSubmit={this.submitHandler('minPrice')}>
              <Textfield
                label="Min"
                value={renderPrice(this.state.minPrice)}
                classNames={textFieldClassNames}
                onChange={this.updatePrice('minPrice')}
                onBlur={() => this.onBlur('minPrice')}
              />
            </form>
          </div>
          <div className={style.priceField}>
            <form onSubmit={this.submitHandler('maxPrice')}>
              <Textfield
                label="Max"
                value={renderPrice(this.state.maxPrice)}
                classNames={textFieldClassNames}
                onChange={this.updatePrice('maxPrice')}
                onBlur={() => this.onBlur('maxPrice')}
              />
            </form>
          </div>
        </Container>
      </Container>
    )
  }
}

export default withRouter(PriceFilter)
